export default "__VITE_ASSET__BpZ9NkxB__"